// [init]

export default {


	namespaced: true,

	state: {
		// Listing of all promoCodes ( Array )
		promoCodesList: [],

		// Current PromoCode being manipulated ( viewed or edited ) ( Object )
		status: '',
		activePromoCode: {}
	},

	mutations: {

		// Update promoCodeList with new list
		// @params: Array
		updatePromoCodeList( state, newList ) {
			state.promoCodesList = newList;
		},

		// Add a promoCode into promoCodeList
		addPromoCode( state, newPromoCode ) {
			state.promoCodesList.push( newPromoCode );
		},

		// Delete a promoCode from promoCodeList
		// @params: identifier (String)
		deletePromoCode( state, identifier ) {
			state.promoCodesList = state.promoCodesList.filter( promoCode => {
				return promoCode.id != identifier;
			} );
		},

		// Update the current active PromoCode object
		// @params: newActivePromoCode (Object)
		updateActivePromoCode( state, newActivePromoCode ) {
			state.activePromoCode = newActivePromoCode;
		},

		// Change status of promoCodeForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activePromoCode = {};
		}

	},

	actions: {
		
		/* 
		*  /GET promoCodes API
		*  Get all promoCodes from the server
		*  @return: Array
		*/
		getPromoCodes( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/promocodes',
					params: {
						trash: this.state.auth.type == 'admin' ? '*' : '0',
						from: 0,
						size: 9999999
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updatePromoCodeList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id promoCodes API
		*  Get a single promoCode from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSinglePromoCode( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/promocodes/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateActivePromoCode', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST promoCodes API
		*  Add a new promoCode to the server
		*  @params: Object (promoCodes data)
		*  @return: Object
		*/
		addPromoCode( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				const postData = {
					type: data.type,
					label: data.label,
					code: data.code,
					amount: data.amount,
					remainder: data.totalAllocation,
					startDate: data.startDate,
					endDate: data.endDate,
					booking_type: JSON.stringify(data.booking_type),
					packages: data.packages,
					totalAllocation: data.totalAllocation,
					maxPerCustomer: data.maxPerCustomer
				};

				global.axios.request({
					method: 'post',
					url: '/promocodes',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addPromoCode', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id promoCodes API
		*  Edits an existing promoCode into the server
		*  @params: Object (promoCodes data)
		*  @return: Object
		*/
		editPromoCode( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {

				const postData = {
					type: data.type,
					label: data.label,
					code: data.code,
					amount: data.amount,
					remainder: data.remainder,
					startDate: data.startDate,
					endDate: data.endDate,
					booking_type: JSON.stringify(data.booking_type),
					packages: data.packages,
					totalAllocation: data.totalAllocation,
					maxPerCustomer: data.maxPerCustomer
				};

				global.axios.request({
					method: 'post',
					url: '/promocodes/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addPromoCode', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id promoCodes API
		*  Removes an existing promoCode into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deletePromoCode( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/promocodes/' + identifier + '/trash',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deletePromoCode', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST/:id/untrash promocodes API
		*  Restores a promocode into the server from the trash
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		untrashPromoCode( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'post',
					url: '/promocodes/' + identifier + '/untrash',
					validateStatus: ( status ) => { return status == 200; },
				})
				.then(response => {
					const updatedList = state.promoCodesList.map(item => {
						if (item.id === identifier ) {
							let holder = item;
							holder.trash = 0;
							return holder;
						} else {
							return item;
						};
					});
					commit( 'updatePromoCodeList', updatedList );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET promocodes API CSV
		*  Get all promocodes from the server as a CSV
		*  (different headers)
		*  @return: Array
		*/
		getPromoCodesCsv( { commit } ) {

			window.open( process.env.ENDPOINT + '/promocodes?download=1&from=0&size=9999999' );

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Promocodes.js